import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import MasterComponent from '../../common/MasterComponent';
import PopUp from '../../components/Popup';
import Chip from '@mui/material/Chip';
import { buildUseCaseActions } from '../../store/reducers/build-usecases';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { GridValueGetterParams } from '@mui/x-data-grid';
import { ChipColorTypes, UseCaseTypes } from './useCases-Types';
import Typography from '@mui/material/Typography';
import { ontologyMasterActions } from '../../store/reducers/ontology-master';
import { ReactComponent as AlertIcon } from '../../assets/icons/main/alertIcon.svg';
import { ReactComponent as SuccessIcon } from '../../assets/icons/main/successIcon.svg';
import { gatewayMasterActions } from '../../store/reducers/gateway-master';
import { machineryManagementActions } from '../../store/reducers/machinery-management';
import { componentMasterActions } from '../../store/reducers/component-master';
import { Upload } from '@mui/icons-material';
import { sentenceCase } from 'change-case';
import useNotification from '../../common/notification';
import { addUseCaseDefaultFields } from './form';
import { Stack, Tabs, Tab, Tooltip, useTheme } from '@mui/material';
import FactoryFormModal from '../../common/factoryFormModal';
import { useCaseMetaDataSchema, useCaseSchema, useCaseUISchema } from './form';
import { pageActions } from '../../store/reducers/page-actions';
import { factoryManagementActions } from '../../store/reducers/factory-management';
import UseCaseFormModal from '../../common/useCaseFormModal';
import Snackbar from '../../common/snackBar';
import {palette} from '../../theme/palette';

import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../utils/table-utils';
import { notificationActions } from '../../store/reducers/notification';
import { UseCasesDataRequestPayloadTypes } from '../../store/models/use-cases';
import { get } from 'lodash';

const Styles = {
  cursorPointer: { cursor: 'pointer' },
  icon: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
    color: '#51648F',
  },
  displayName: {
    cursor: 'pointer',
    fontWeight: 400,
    fontSize: '1rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
};

const getChipText = (item: string) => item.split('_').join(' ');

const BuildDeployUsecase = ({
  isUseCasesListLoading,
  useCasesList,
  useCasesListTotalRowCount,
  useCasesListPageNumber,
  isAddUseCaseSuccess,
  isAddUseCaseError,
  ontologyData,
  isRemoveUseCaseSuccess,
  isRemoveUseCaseError,
  isUpdateUseCaseSuccess,
  isUpdateUseCaseError,
  isUseCaseDeployed,
  ontologyMgmntData,
  useCaseErrorMessage,
  useCasesListError,
  factoriesList,
  gateways,
  onTabChange,
  selectedTab,
  filterStatus,
  isUpdateUseCaseStatusSuccess,
  isUpdateUseCaseStatusError,
  searchItem,
}: UseCaseTypes) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [msg, sendNotification] = useNotification();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [addUseCaseData, setAddUseCaseData] = useState<any>(addUseCaseDefaultFields);
  const [useCaseTagsData, setUseCaseTagsData] = useState<any[]>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [useCaseMasterData, setUseCaseMasterData] = useState<any>();
  const [confirmPopup, setConfirmPopup] = useState<any>(false);
  const { pathname } = useLocation();
  const [popupData, setPopupData] = useState<any>({
    show: false,
    title: '',
    message: '',
    confirmLabel: '',
    cancelLabel: '',
    confirmation: false,
    icon: <SuccessIcon  style={{ color: palette.success.dark }}   />,
    onConfirm: null,
    cancel: true,
  });
  const [editOntoData, setEditOntoData] = useState<any>([]);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [hiddenColumns, setHiddenColumns] = useState<any>({});
  const [sortingModel, setSortingModel] = useState({ field: '', sort: '' });

  const dispatchUseCasesDataRequest = (payload: UseCasesDataRequestPayloadTypes) => {
    dispatch(
      buildUseCaseActions.getAllUseCasesDataRequest({
        ...sortingModel,
        filter_status: filterStatus,
        search_item: searchItem,
        ...payload,
      })
    );
  };

  useEffect(() => {
    dispatchUseCasesDataRequest({
      limit: DEFAULT_PAGE_SIZE,
      page: DEFAULT_PAGE_NUMBER,
    });
    dispatch(ontologyMasterActions.getOntologyList(''));
    dispatch(ontologyMasterActions.getOntologyMgmntList(''));
    dispatch(factoryManagementActions.getFactoriesList());
    dispatch(gatewayMasterActions.getGatewayDataRequest());
    if (selectedTab === 1) {
      setHiddenColumns({ actions: false });
    } else {
      setHiddenColumns({});
    }
    return () => {
      dispatch(buildUseCaseActions.resetLoadingState());
      dispatch(buildUseCaseActions.resetUsecaseDate());
      dispatch(factoryManagementActions.resetFactoryData());
    };
  }, [selectedTab]);

  const onSave = (payload: any) => {
    if (isEdit) {
      dispatch(buildUseCaseActions.updateUseCaseRequest(payload));
    } else {
      dispatch(buildUseCaseActions.addUseCaseRequest(payload));
    }
  };

  useEffect(() => {
    if (isUseCaseDeployed) {
      sendNotification({
        msg: 'Use case deployment started successfully',
        variant: 'success',
        dispatchAction: buildUseCaseActions.resetLoadingState(),
      });
    }

    if (isAddUseCaseSuccess || isUpdateUseCaseSuccess || isRemoveUseCaseSuccess || isUpdateUseCaseStatusSuccess) {
      setSelectedRows([]);
      dispatchUseCasesDataRequest({
        limit: DEFAULT_PAGE_SIZE,
        page:
          isRemoveUseCaseSuccess && useCaseMasterData.length === 1 && useCasesListPageNumber !== 1
            ? useCasesListPageNumber - 1
            : useCasesListPageNumber,
      });
    }

    if (isUpdateUseCaseStatusError) {
      setSelectedRows([]);
    }
  }, [
    isAddUseCaseSuccess,
    isRemoveUseCaseSuccess,
    isUpdateUseCaseSuccess,
    isUseCaseDeployed,
    isUpdateUseCaseStatusSuccess,
    isUpdateUseCaseStatusError,
  ]);

  const handleEdit = (payload: any) => {
    let ontoId = payload.onto_manage_id;
    if (ontologyMgmntData.length > 0) {
      let tempOntoData: any = [];
      restartTheLoop: while (true) {
        for (const item of ontologyMgmntData) {
          if (item.onto_manage_id == ontoId) {
            tempOntoData.unshift(item);
            ontoId = item.parent_id;
            continue restartTheLoop;
          }
        }
        break;
      }

      setEditOntoData(
        tempOntoData.map((item: any) => {
          let getLevelName = ontologyData.filter((data: any) => {
            return data.id === item.onto_level_number;
          })[0];
          return {
            ...item,
            level_name: getLevelName?.level_name || '',
          };
        })
      );
    }
    setIsEdit(true);
    setAddUseCaseData(payload);
    setUseCaseTagsData(payload.use_case_tags || []);
    setIsModalOpen(true);
  };

  const handleDelete = (payload: any) => {
    setAddUseCaseData(payload);
    setConfirmPopup(true);
  };

  const handleActions = (data: any, type: any) => {
    if (type === 'confirm') {
      dispatch(buildUseCaseActions.removeUseCaseRequest(addUseCaseData));
      setAddUseCaseData(addUseCaseDefaultFields);
      setConfirmPopup(false);
    } else if (type === 'warning') {
      setAddUseCaseData(addUseCaseDefaultFields);
      setConfirmPopup(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsEdit(false);
    setAddUseCaseData(addUseCaseDefaultFields);
    setUseCaseTagsData([]);
  };

  const closeAlertModal = () => {
    setPopupData({
      show: false,
      title: '',
      message: '',
      confirmLabel: '',
      cancelLabel: '',
      confirmation: true,
      icon: <AlertIcon color={palette.warning.main} />,
      onConfirm: null,
      cancel: true,
    });
    dispatch(buildUseCaseActions.resetLoadingState());
  };

  const onUseCaseClick = (params: GridValueGetterParams) => {
    // dispatch(buildUseCaseActions.getUseCaseDataRequest(useCaseId));
    // dispatch(gatewayMasterActions.getGatewayDataRequest());
    // dispatch(machineryManagementActions.getMachineryManagementDataRequest());
    // dispatch(componentMasterActions.getServicesDataRequest());

    const useCaseId = String(params.id);
    navigate(useCaseId);
  };

  const columns = [
    {
      field: 'use_case_name',
      headerName: 'USE CASE DISPLAY NAME',
      resizable: false,
      headerAlign: 'left',
      align: 'left',
      flex: 1,
      minWidth: 250,
      renderCell: (params: GridValueGetterParams) => {
        return (
          <Tooltip title={params.value} placement='bottom' arrow>
            <Typography component='span' color='primary' sx={Styles.displayName} onClick={() => onUseCaseClick(params)}>
              {params.value}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'no_of_egs',
      headerName: 'NO. OF EGS',
      headerAlign: 'center',
      resizable: false,
      align: 'center',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'configured_egs',
      headerName: 'CONFIGURED EGS',
      headerAlign: 'center',
      resizable: false,
      align: 'center',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'not_configured_egs',
      headerName: 'NOT CONFIGURED EGS',
      headerAlign: 'center',
      resizable: false,
      align: 'center',
      flex: 1,
      minWidth: 250,
    },
    {
      field: 'deployed_egs',
      headerName: 'DEPLOYED EGS',
      headerAlign: 'center',
      resizable: false,
      align: 'center',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'status',
      headerName: 'STATUS',
      headerAlign: 'left',
      align: 'left',
      resizable: false,
      flex: 1,
      minWidth: 200,
      renderCell: (params: GridValueGetterParams) => {
        return (
          <Chip label={sentenceCase(params.value ?? '')} key={params.id} className={params.value} variant='outlined' />
        );
      },
    },
  ];

  const handleRowSelection = (params: any) => {
    setSelectedRows(params);
  };

  const onStatusChange = (approvalType: string) => {
    if (selectedRows.length) {
      const payload: any = useCaseMasterData
        .filter((item: any) => selectedRows.includes(item.id))
        .map((item: any) => {
          if (approvalType != '') {
            return { ...item, status: approvalType };
          } else {
            return { ...item };
          }
        });
      dispatch(buildUseCaseActions.updateUseCaseStatusRequest(payload));
      dispatch(notificationActions.getNotificationDataRequest(''));
    } else {
      Snackbar.info('Please select use-case');
    }
  };

  const isRowSelectable = (params: any) => {
    return !['approved', 'rejected', 'deployed'].includes(params.row.status);
  };

  const successAlertModal = () => {
    navigate('/assets/ontology');
  };

  const onModalOpen = () => {
    if (ontologyMgmntData && ontologyMgmntData.length > 0) {
      setIsModalOpen(true);
    } else {
      setPopupData({
        show: true,
        title: 'Ontologies are not present',
        message: 'Please add ontology before adding New use case?',
        confirmLabel: 'Go to Ontology Management',
        cancelLabel: 'Cancel',
        confirmation: true,
        icon: <AlertIcon color={palette.warning.main} />,
        onConfirm: successAlertModal,
        cancel: true,
      });
    }
  };
  // const pageData : any = get(useOutletContext(),'outletData',{});
  const themeData : any = useTheme();

  const renderModal = () => (
    <UseCaseFormModal
      title={`${isEdit ? 'Edit' : 'Add New'} Use Case`}
      isModalOpen={isModalOpen}
      data={addUseCaseData}
      setData={setAddUseCaseData}
      tags={useCaseTagsData}
      setTags={setUseCaseTagsData}
      ontologyData={ontologyData}
      isEdit={isEdit}
      closeModal={closeModal}
      onSave={onSave}
      gateways={gateways}
      factories={factoriesList}
      uiSchema={useCaseUISchema}
      dataSchema={useCaseSchema}
      metaDataSchema={useCaseMetaDataSchema}
      isFrom='useCase'
      editOntoData={editOntoData}
    />
  );

  // useEffect(() => {
  //   if (selectedTab === 1) {
  //     setHiddenColumns({ 'actions': false })
  //   } else {
  //     setHiddenColumns({})
  //   }
  // }, [selectedTab])

  useEffect(() => {
    if (useCasesList && useCasesList.length > 0) {
      if (selectedTab === 1) {
        setUseCaseMasterData(
          useCasesList
            .map((item: any) => {
              return {
                ...item,
                id: item.use_case_id,
                use_case_tags:
                  item.use_case_tags && item.use_case_tags.length > 0
                    ? item.use_case_tags.map((val: any, index: any) => {
                      return { ...val, id: index + 1 };
                    })
                    : [],
              };
            })
            .filter((item: any) => item.status === 'waiting_for_approval')
        );
      } else {
        setUseCaseMasterData(
          useCasesList
            .map((item: any) => {
              return {
                ...item,
                id: item.use_case_id,
                use_case_tags:
                  item.use_case_tags && item.use_case_tags.length > 0
                    ? item.use_case_tags.map((val: any, index: any) => {
                      return { ...val, id: index + 1 };
                    })
                    : [],
              };
            })
            .filter((item: any) => item.status != 'waiting_for_approval')
        );
      }
    } else {
      setUseCaseMasterData([]);
    }

    // if (pathname.length) {
    //   const pathnamesTemp: any = pathname.split('/').filter((item: any) => item != 'one');
    //   if (pathnamesTemp.length) {
    //     const pathnamesData: any = pathnamesTemp
    //       .filter((i: any, index: number) => index > 0)
    //       .map((item: any, index: number) => {
    //         return { route: pathnamesTemp[0] + '/' + pathnamesTemp[1], pathName: item, navigate: false };
    //       });
    //     dispatch(pageActions.setPagePath(pathnamesData));
    //   }
    // }
    // return () => {
    //   const data: any = [];
    //   dispatch(pageActions.setPagePath(data));
    // };
  }, [useCasesList, pathname]);

  return (
    <>
      <MasterComponent
        heading={
          <Tabs value={selectedTab} onChange={onTabChange} TabIndicatorProps={{
            style: {
              backgroundColor: themeData.palette.primary.main,
            },
          }} >
            <Tab label='List of Use Cases' />
            <Tab label='Pending Approvals' />
          </Tabs>
        }
        isFromUseCase
        selectedTab={selectedTab}
        isLoading={isUseCasesListLoading}
        disableRowSelectionOnClick={true}
        rows={useCaseMasterData}
        columns={columns}
        isServerPagination
        totalRowCount={useCasesListTotalRowCount}
        pageNumber={useCasesListPageNumber}
        onPagination={(pageSize: number, pageNumber: number) => {
          dispatchUseCasesDataRequest({
            limit: pageSize,
            page: pageNumber,
          });
        }}
        onSorting={(sortModel: { field: string; sort: string }) => {
          dispatchUseCasesDataRequest({
            limit: DEFAULT_PAGE_SIZE,
            page: useCasesListPageNumber,
            ...sortModel,
          });
          setSortingModel(sortModel);
        }}
        setIsModalOpen={onModalOpen}
        checkboxSelection
        onRowSelectionChange={handleRowSelection}
        onStatusChange={onStatusChange}
        hiddenColumns={hiddenColumns}
        selectionModel={selectedRows}
        isRowSelectable={isRowSelectable}
        noRowsOverlay={() => (
          <Stack height='100%' alignItems='center' justifyContent='center'>
            Use-Case data not available
          </Stack>
        )}
        actionsColumn={{
          edit: {
            onClick: (params: GridValueGetterParams) => handleEdit(params.row),
          },
          delete: {
            onClick: (params: GridValueGetterParams) => handleDelete(params.row),
          },
        }}
        showSearch
        searchPlaceholder='Use Case Name'
        onSearch={(searchValue: string) => {
          dispatchUseCasesDataRequest({
            limit: DEFAULT_PAGE_SIZE,
            page: DEFAULT_PAGE_NUMBER,
            search_item: searchValue,
          });
          dispatch(buildUseCaseActions.onSearchForItem(searchValue));
        }}
      />
      <PopUp
        open={confirmPopup}
        icon={<AlertIcon color={palette.warning.main} />}
        message='Are you sure to delete this Use Case?'
        cancel={true}
        confirmation={true}
        cancelLabel='No'
        confirmLabel='Yes'
        onConfirm={() => handleActions({}, 'confirm')}
        onClose={() => handleActions({}, 'warning')}
        onCancel={() => handleActions({}, 'warning')}
      />
      <PopUp
        title={popupData.title}
        open={popupData.show}
        icon={popupData.icon}
        message={popupData?.message}
        confirmation
        confirmLabel={popupData?.confirmLabel}
        onConfirm={popupData.onConfirm}
        cancel={popupData.cancel}
        cancelLabel={popupData.cancelLabel}
        onCancel={closeAlertModal}
        onClose={closeAlertModal}
      />
      {renderModal()}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  isUseCasesListLoading: state.buildUseCase.isUseCasesListLoading,
  useCasesList: state.buildUseCase.useCasesList,
  useCasesListTotalRowCount: state.buildUseCase.useCasesListTotalRowCount,
  useCasesListPageNumber: state.buildUseCase.useCasesListPageNumber,
  isUseCaseDeployed: state.buildUseCase.isUseCaseDeployed,
  isAddUseCaseSuccess: state.buildUseCase.isAddUseCaseSuccess,
  isAddUseCaseError: state.buildUseCase.isAddUseCaseError,
  ontologyData: state.ontologyMaster.ontologyData,
  isRemoveUseCaseSuccess: state.buildUseCase.isRemoveUseCaseSuccess,
  isRemoveUseCaseError: state.buildUseCase.isRemoveUseCaseError,
  isUpdateUseCaseSuccess: state.buildUseCase.isUpdateUseCaseSuccess,
  isUpdateUseCaseError: state.buildUseCase.isUpdateUseCaseError,
  ontologyMgmntData: state.ontologyMaster.ontologyMgmntData,
  useCaseErrorMessage: state.buildUseCase.useCaseErrorMessage,
  useCasesListError: state.buildUseCase.useCasesListError,
  isUpdateUseCaseStatusSuccess: state.buildUseCase.isUpdateUseCaseStatusSuccess,
  isUpdateUseCaseStatusError: state.buildUseCase.isUpdateUseCaseStatusError,
  searchItem: state.buildUseCase.searchItem,
  factoriesList: state.factoryManagement.factoriesList,
  gateways: state.gatewayMaster.gatewayMasterData,
});

export default connect(mapStateToProps)(BuildDeployUsecase);
